import React from 'react';
import BaseIntegration from 'screens/Integrations/components/BaseIntegration';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import StepSelector, { PROPERTIES_SELECTION_STEP } from '../StepSelector';

const progressBarSteps = [
  {
    caption: 'Sign in'
  },
  {
    caption: 'Select Organization'
  },
  {
    caption: 'Select Crop Seasons'
  },
  {
    caption: 'Select Properties'
  },
  {
    caption: 'Match Fields'
  },
  {
    caption: 'Review and Submit'
  }
];

const BaseAgrianIntegration = () => {
  return (
    <BaseIntegration
      integrationType={INTEGRATIONS.agrian}
      progressBarSteps={progressBarSteps}
      selectPropertiesStep={PROPERTIES_SELECTION_STEP}
      StepSelector={StepSelector}
    />
  );
};

export default BaseAgrianIntegration;
